export const SPOTLIGHT_FORM_FACTOR_GATE = 'LiveChat:SpotlightFormFactor';
export const NARROW_POST_MESSAGE_TARGET_ORIGIN_GATE = 'LiveChat:NarrowPostMessageTargetOrigin';